/**
 * PortalGatekeeper.jsx
 * Wrapper for personal portal routes (student, teacher, corporate).
 *
 * - If user IS impersonating → show portal normally (children)
 * - If user HAS the actual role (not superadmin bypass) → show portal normally
 * - Otherwise → show PortalUserSelector to pick a user to impersonate
 */
import React, { useMemo } from 'react';
import useAuth from '@/modules/auth/useAuth';
import PortalUserSelector from './PortalUserSelector';

const PortalGatekeeper = ({ roleName, portalDashboardPath, children }) => {
  const { user, isImpersonating } = useAuth();

  // Check if user genuinely has this role (bypass superadmin shortcut)
  const hasActualRole = useMemo(() => {
    if (!user) return false;
    return user.profiles?.some(
      p => p.role?.name === roleName && p.is_active
    ) || false;
  }, [user, roleName]);

  // If impersonating or genuinely has the role → render portal
  if (isImpersonating || hasActualRole) {
    return children;
  }

  // Otherwise → show user selector
  return <PortalUserSelector roleName={roleName} portalDashboardPath={portalDashboardPath} />;
};

export default PortalGatekeeper;
